// src/data/polesData.js - Contains all pole product data
import { getPriceComparisonUrl } from '../utils/productUrlMapping';

export const polesData = [
  // BeatDown BreakAway Pole with Toggle Options (for selection interface)
  {
    id: "beatdown-pole-selector",
    name: "BeatDown Outdoors BreakAway Transducer Pole",
    msrp: 550.00, // Base price (will be calculated based on selections)
    image: "https://thebasstank.com/cdn/shop/products/BD-OUT-TPOLE-BA_ad7eb408-0f90-4de2-a558-7c60e5e44d18.jpg?v=1689628624",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=BeatDown+Pole",
    description: "The best livescope transducer pole mount on the market. Breakaway pole is 2 poles in 1, with fixed and breakaway positions. Locks every 90 degrees for easy water exit.",
    bestFor: "Professional Anglers",
    notes: "Patent No. US 11,021,215 B1. Does NOT come with mounting hardware. WARNING: REMOVE UNIT WHEN TRAILERING",
    armOptions: {
      "all-terrain": {
        name: "All-Terrain", 
        description: "3-section pole: aluminum handle + 36\" aluminum mid + 24\" PVC bottom",
        price: 575.00,
        sections: "3 sections",
        maxLength: "60 inches without handle",
        flexibility: "Extra flexibility from PVC bottom section"
      },
      "original": {
        name: "Original",
        description: "2-section pole: adjustable aluminum handle + 48\" aluminum section",
        price: 550.00,
        sections: "2 sections",
        maxLength: "72 inches with extension (sold separately)",
        flexibility: "Standard rigidity"
      }
    },
    mountOptions: {
      "track": {
        name: "Track Mount",
        description: "Designed for track-based mounting systems with secure locking mechanism",
        price: 75.00,
        compatibility: "Standard track systems",
        installation: "Slides into track, locks with twist mechanism"
      },
      "flat": {
        name: "Deck Mount",
        description: "Universal deck surface mounting with adjustable base plate",
        price: 50.00,
        compatibility: "Any deck surface",
        installation: "Bolts directly to deck surface with included hardware"
      }
    },
    poleTypeOptions: {
      "breakaway": {
        name: "BreakAway",
        description: "Patent-pending breakaway design prevents transducer damage",
        price: 100.00,
        features: "90-degree locking, damage prevention",
        bestFor: "High-traffic areas"
      },
      "fixed": {
        name: "Fixed (Non-Pivoting)",
        description: "Fixed position pole for stable, permanent positioning",
        price: 0.00,
        features: "Maximum stability, no moving parts",
        bestFor: "Permanent installations"
      }
    },
    construction: "Marine grade aluminum",
    poleLength: "36-48 inches",
    poleType: "Open Water Breakaway",
    handleLength: "15 inches (fully extended)",
    armSize: "10\" x 10\" (8\" to clear gunnel)",
    baseSize: "3\" x 4\"",
    lockingSystem: "90-degree incremental locking",
    weight: "Professional grade",
    patentNumber: "US 11,021,215 B1",
    releaseYear: "2022",
    benefits: [
      "Breakaway design prevents transducer damage",
      "90-degree locking in both directions", 
      "Professional marine grade construction",
      "Two poles in one (fixed + breakaway positions)",
      "Market leading livescope pole mount"
    ]
  },
  {
    id: "hdi-carbon-open-water-pole",
    name: "HD Innovations Carbon Open Water FFS Pole",
    msrp: 116.99,
    image: "https://www.hdinnovations.com/cdn/shop/files/PXL_20250314_210026096-Photoroom.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HD+Carbon+Pole",
    description: "Lightweight carbon fiber telescoping pole system crafted to withstand elements on both ice and open water. Features Patent Pending 'Slide and Lock' transducer mount.",
    notes: "Weighs less than 1.75lbs - lightest pole system available. UMS pole mounting not included but fully compatible with HD UMS system.",
    lengthOptions: {
      "18-36": {
        name: "18\"-36\"",
        usableLength: "22\"min - 40\"max"
      },
      "24-60": {
        name: "24\"-60\"", 
        usableLength: "28\"min - 64\"max"
      },
      "32-80": {
        name: "32\"-80\"",
        usableLength: "36\"min - 84\"max"
      }
    },
    transducerOptions: {
      "LVS34": {
        name: "LVS34",
        description: "For Garmin LVS34 transducers"
      },
      "LVS32": {
        name: "LVS32",
        description: "For Garmin LVS32 transducers"
      }
    },
    // Pricing matrix based on length + transducer combinations
    pricingMatrix: {
      "18-36": {
        "LVS34": 116.99,
        "LVS32": 114.99
      },
      "24-60": {
        "LVS34": 126.99,
        "LVS32": 124.99
      },
      "32-80": {
        "LVS34": 136.99,
        "LVS32": 134.99
      }
    },
    construction: "3K Carbon Fiber Telescoping",
    poleType: "Open Water & Ice",
    weight: "Less than 1.75lbs",
    poleDiameters: "Upper 1.125\" / Mid 1\" / Lower .875\"",
    mountType: "HD Multi-Mount with Perspective Mode",
    lockingSystem: "0-degree lock with 90-degree imaging",
    included: "Carbon pole, Handle, HD Multi-mount, Cable clips, Connection hardware",
    compatibility: "HDI Shuttle, HD UMS System, HD Ice Tripods",
    releaseYear: "2024",
    bestFor: "All Anglers",
    benefits: [
      "Lightest pole system available at <1.75lbs",
      "Patent Pending Slide and Lock design",
      "Works on both ice and open water",
      "Tool-free transducer adjustment",
      "Compatible with all major transducers"
    ]
  },
  
  // Individual HD Innovations products (for direct product page access)
  {
    id: "hdi-carbon-18-36-lvs34",
    name: "HD Innovations Carbon Open Water FFS Pole - 18\"-36\" - LVS34",
    msrp: 116.99,
    csvLookupId: "HDI Carbon Open Water FFS Pole 18-36 LVS34",
    priceComparisonUrl: getPriceComparisonUrl("HDI Carbon Open Water FFS Pole 18-36 LVS34"),
    image: "https://www.hdinnovations.com/cdn/shop/files/PXL_20250314_210026096-Photoroom.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HD+Carbon+18-36+LVS34",
    description: "Lightweight 18\"-36\" carbon fiber telescoping pole system for LVS34 transducers. Features Patent Pending 'Slide and Lock' transducer mount with 22\"min - 40\"max usable length.",
    bestFor: "All Anglers",
    notes: "Weighs less than 1.75lbs - lightest pole system available. UMS pole mounting not included but fully compatible with HD UMS system.",
    configuration: "18\"-36\" + LVS34",
    construction: "3K Carbon Fiber Telescoping",
    poleType: "Open Water & Ice",
    lengthRange: "18\"-36\"",
    usableLength: "22\"min - 40\"max",
    transducerType: "LVS34",
    weight: "Less than 1.75lbs",
    poleDiameters: "Upper 1.125\" / Mid 1\" / Lower .875\"",
    mountType: "HD Multi-Mount with Perspective Mode",
    lockingSystem: "0-degree lock with 90-degree imaging",
    included: "Carbon pole, Handle, HD Multi-mount, Cable clips, Connection hardware",
    compatibility: "HDI Shuttle, HD UMS System, HD Ice Tripods",
    releaseYear: "2024",
    benefits: [
      "Lightest pole system available at <1.75lbs",
      "Patent Pending Slide and Lock design",
      "Works on both ice and open water",
      "Tool-free transducer adjustment",
      "Optimized for LVS34 transducers"
    ],
    hiddenFromSelection: true
  },
  {
    id: "hdi-carbon-18-36-lvs32",
    name: "HD Innovations Carbon Open Water FFS Pole - 18\"-36\" - LVS32",
    msrp: 114.99,
    csvLookupId: "HDI Carbon Open Water FFS Pole 18-36 LVS32",
    priceComparisonUrl: getPriceComparisonUrl("HDI Carbon Open Water FFS Pole 18-36 LVS32"),
    image: "https://www.hdinnovations.com/cdn/shop/files/PXL_20250314_210026096-Photoroom.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HD+Carbon+18-36+LVS32",
    description: "Lightweight 18\"-36\" carbon fiber telescoping pole system for LVS32 transducers. Features Patent Pending 'Slide and Lock' transducer mount with 22\"min - 40\"max usable length.",
    bestFor: "All Anglers",
    notes: "Weighs less than 1.75lbs - lightest pole system available. UMS pole mounting not included but fully compatible with HD UMS system.",
    configuration: "18\"-36\" + LVS32",
    construction: "3K Carbon Fiber Telescoping",
    poleType: "Open Water & Ice",
    lengthRange: "18\"-36\"",
    usableLength: "22\"min - 40\"max",
    transducerType: "LVS32",
    weight: "Less than 1.75lbs",
    poleDiameters: "Upper 1.125\" / Mid 1\" / Lower .875\"",
    mountType: "HD Multi-Mount with Perspective Mode",
    lockingSystem: "0-degree lock with 90-degree imaging",
    included: "Carbon pole, Handle, HD Multi-mount, Cable clips, Connection hardware",
    compatibility: "HDI Shuttle, HD UMS System, HD Ice Tripods",
    releaseYear: "2024",
    benefits: [
      "Lightest pole system available at <1.75lbs",
      "Patent Pending Slide and Lock design",
      "Works on both ice and open water",
      "Tool-free transducer adjustment",
      "Optimized for LVS32 transducers"
    ],
    hiddenFromSelection: true
  },
  {
    id: "hdi-carbon-24-60-lvs34",
    name: "HD Innovations Carbon Open Water FFS Pole - 24\"-60\" - LVS34",
    msrp: 126.99,
    csvLookupId: "HDI Carbon Open Water FFS Pole 24-60 LVS34",
    priceComparisonUrl: getPriceComparisonUrl("HDI Carbon Open Water FFS Pole 24-60 LVS34"),
    image: "https://www.hdinnovations.com/cdn/shop/files/PXL_20250314_210026096-Photoroom.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HD+Carbon+24-60+LVS34",
    description: "Mid-range 24\"-60\" carbon fiber telescoping pole system for LVS34 transducers. Features Patent Pending 'Slide and Lock' transducer mount with 28\"min - 64\"max usable length.",
    bestFor: "All Anglers",
    notes: "Weighs less than 1.75lbs - lightest pole system available. UMS pole mounting not included but fully compatible with HD UMS system.",
    configuration: "24\"-60\" + LVS34",
    construction: "3K Carbon Fiber Telescoping",
    poleType: "Open Water & Ice",
    lengthRange: "24\"-60\"",
    usableLength: "28\"min - 64\"max",
    transducerType: "LVS34",
    weight: "Less than 1.75lbs",
    poleDiameters: "Upper 1.125\" / Mid 1\" / Lower .875\"",
    mountType: "HD Multi-Mount with Perspective Mode",
    lockingSystem: "0-degree lock with 90-degree imaging",
    included: "Carbon pole, Handle, HD Multi-mount, Cable clips, Connection hardware",
    compatibility: "HDI Shuttle, HD UMS System, HD Ice Tripods",
    releaseYear: "2024",
    benefits: [
      "Lightest pole system available at <1.75lbs",
      "Patent Pending Slide and Lock design",
      "Works on both ice and open water",
      "Tool-free transducer adjustment",
      "Optimized for LVS34 transducers"
    ],
    hiddenFromSelection: true
  },
  {
    id: "hdi-carbon-24-60-lvs32",
    name: "HD Innovations Carbon Open Water FFS Pole - 24\"-60\" - LVS32",
    msrp: 124.99,
    csvLookupId: "HDI Carbon Open Water FFS Pole 24-60 LVS32",
    priceComparisonUrl: getPriceComparisonUrl("HDI Carbon Open Water FFS Pole 24-60 LVS32"),
    image: "https://www.hdinnovations.com/cdn/shop/files/PXL_20250314_210026096-Photoroom.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HD+Carbon+24-60+LVS32",
    description: "Mid-range 24\"-60\" carbon fiber telescoping pole system for LVS32 transducers. Features Patent Pending 'Slide and Lock' transducer mount with 28\"min - 64\"max usable length.",
    bestFor: "All Anglers",
    notes: "Weighs less than 1.75lbs - lightest pole system available. UMS pole mounting not included but fully compatible with HD UMS system.",
    configuration: "24\"-60\" + LVS32",
    construction: "3K Carbon Fiber Telescoping",
    poleType: "Open Water & Ice",
    lengthRange: "24\"-60\"",
    usableLength: "28\"min - 64\"max",
    transducerType: "LVS32",
    weight: "Less than 1.75lbs",
    poleDiameters: "Upper 1.125\" / Mid 1\" / Lower .875\"",
    mountType: "HD Multi-Mount with Perspective Mode",
    lockingSystem: "0-degree lock with 90-degree imaging",
    included: "Carbon pole, Handle, HD Multi-mount, Cable clips, Connection hardware",
    compatibility: "HDI Shuttle, HD UMS System, HD Ice Tripods",
    releaseYear: "2024",
    benefits: [
      "Lightest pole system available at <1.75lbs",
      "Patent Pending Slide and Lock design",
      "Works on both ice and open water",
      "Tool-free transducer adjustment",
      "Optimized for LVS32 transducers"
    ],
    hiddenFromSelection: true
  },
  {
    id: "hdi-carbon-32-80-lvs34",
    name: "HD Innovations Carbon Open Water FFS Pole - 32\"-80\" - LVS34",
    msrp: 136.99,
    csvLookupId: "HDI Carbon Open Water FFS Pole 32-80 LVS34",
    priceComparisonUrl: getPriceComparisonUrl("HDI Carbon Open Water FFS Pole 32-80 LVS34"),
    image: "https://www.hdinnovations.com/cdn/shop/files/PXL_20250314_210026096-Photoroom.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HD+Carbon+32-80+LVS34",
    description: "Extended 32\"-80\" carbon fiber telescoping pole system for LVS34 transducers. Features Patent Pending 'Slide and Lock' transducer mount with 36\"min - 84\"max usable length.",
    bestFor: "All Anglers",
    notes: "Weighs less than 1.75lbs - lightest pole system available. UMS pole mounting not included but fully compatible with HD UMS system.",
    configuration: "32\"-80\" + LVS34",
    construction: "3K Carbon Fiber Telescoping",
    poleType: "Open Water & Ice",
    lengthRange: "32\"-80\"",
    usableLength: "36\"min - 84\"max",
    transducerType: "LVS34",
    weight: "Less than 1.75lbs",
    poleDiameters: "Upper 1.125\" / Mid 1\" / Lower .875\"",
    mountType: "HD Multi-Mount with Perspective Mode",
    lockingSystem: "0-degree lock with 90-degree imaging",
    included: "Carbon pole, Handle, HD Multi-mount, Cable clips, Connection hardware",
    compatibility: "HDI Shuttle, HD UMS System, HD Ice Tripods",
    releaseYear: "2024",
    benefits: [
      "Lightest pole system available at <1.75lbs",
      "Patent Pending Slide and Lock design",
      "Works on both ice and open water",
      "Tool-free transducer adjustment",
      "Optimized for LVS34 transducers"
    ],
    hiddenFromSelection: true
  },
  {
    id: "hdi-carbon-32-80-lvs32",
    name: "HD Innovations Carbon Open Water FFS Pole - 32\"-80\" - LVS32",
    msrp: 134.99,
    csvLookupId: "HDI Carbon Open Water FFS Pole 32-80 LVS32",
    priceComparisonUrl: getPriceComparisonUrl("HDI Carbon Open Water FFS Pole 32-80 LVS32"),
    image: "https://www.hdinnovations.com/cdn/shop/files/PXL_20250314_210026096-Photoroom.jpg",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=HD+Carbon+32-80+LVS32",
    description: "Extended 32\"-80\" carbon fiber telescoping pole system for LVS32 transducers. Features Patent Pending 'Slide and Lock' transducer mount with 36\"min - 84\"max usable length.",
    bestFor: "All Anglers",
    notes: "Weighs less than 1.75lbs - lightest pole system available. UMS pole mounting not included but fully compatible with HD UMS system.",
    configuration: "32\"-80\" + LVS32",
    construction: "3K Carbon Fiber Telescoping",
    poleType: "Open Water & Ice",
    lengthRange: "32\"-80\"",
    usableLength: "36\"min - 84\"max",
    transducerType: "LVS32",
    weight: "Less than 1.75lbs",
    poleDiameters: "Upper 1.125\" / Mid 1\" / Lower .875\"",
    mountType: "HD Multi-Mount with Perspective Mode",
    lockingSystem: "0-degree lock with 90-degree imaging",
    included: "Carbon pole, Handle, HD Multi-mount, Cable clips, Connection hardware",
    compatibility: "HDI Shuttle, HD UMS System, HD Ice Tripods",
    releaseYear: "2024",
    benefits: [
      "Lightest pole system available at <1.75lbs",
      "Patent Pending Slide and Lock design",
      "Works on both ice and open water",
      "Tool-free transducer adjustment",
      "Optimized for LVS32 transducers"
    ],
    hiddenFromSelection: true
  },
  
  // Individual BeatDown products (for direct product page access)
  {
    id: "breakaway-pole-track-all-terrain",
    name: "BeatDown BreakAway Transducer Pole - Track Mount - All-Terrain",
    msrp: 550.00, // Updated MSRP
    csvLookupId: "BeatDown BreakAway Transducer Pole - Track Mount - All-Terrain",
    priceComparisonUrl: getPriceComparisonUrl("BeatDown BreakAway Transducer Pole - Track Mount - All-Terrain"),
    image: "https://thebasstank.com/cdn/shop/products/BD-OUT-TPOLE-BA_ad7eb408-0f90-4de2-a558-7c60e5e44d18.jpg?v=1689628624",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=BreakAway+Track+All-Terrain",
    description: "BreakAway pole with Track Mount and All-Terrain arm. The best livescope transducer pole mount on the market. Breakaway pole is 2 poles in 1, with fixed and breakaway positions.",
    bestFor: "Professional Anglers",
    notes: "Patent No. US 11,021,215 B1. Does NOT come with mounting hardware. WARNING: REMOVE UNIT WHEN TRAILERING",
    configuration: "BreakAway + Track Mount + All-Terrain",
    construction: "Marine grade aluminum",
    poleType: "BreakAway",
    mountType: "Track Mount",
    armType: "All-Terrain",
    sections: "3 sections",
    maxLength: "60 inches without handle",
    features: "90-degree locking, damage prevention, extra flexibility",
    benefits: [
      "BreakAway design prevents transducer damage",
      "Track mount compatibility",
      "All-Terrain arm with PVC flexibility",
      "90-degree incremental locking"
    ],
    // Hide from selection interface
    hiddenFromSelection: true
  },
  {
    id: "breakaway-pole-flat-all-terrain",
    name: "BeatDown BreakAway Transducer Pole - Deck Mount - All-Terrain", 
    msrp: 550.00, // Updated MSRP
    csvLookupId: "BeatDown BreakAway Transducer Pole - Deck Mount - All-Terrain",
    priceComparisonUrl: getPriceComparisonUrl("BeatDown BreakAway Transducer Pole - Deck Mount - All-Terrain"),
    image: "https://thebasstank.com/cdn/shop/products/BD-OUT-TPOLE-BA_ad7eb408-0f90-4de2-a558-7c60e5e44d18.jpg?v=1689628624",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=BreakAway+Flat+All-Terrain",
    description: "BreakAway pole with Deck Mount and All-Terrain arm. Patent-pending breakaway design with universal deck surface mounting.",
    bestFor: "Professional Anglers",
    notes: "Patent No. US 11,021,215 B1. Does NOT come with mounting hardware. WARNING: REMOVE UNIT WHEN TRAILERING",
    configuration: "BreakAway + Deck Mount + All-Terrain",
    construction: "Marine grade aluminum",
    poleType: "BreakAway",
    mountType: "Deck Mount", 
    armType: "All-Terrain",
    sections: "3 sections",
    maxLength: "60 inches without handle",
    features: "90-degree locking, damage prevention, extra flexibility",
    benefits: [
      "BreakAway design prevents transducer damage",
      "Universal deck surface mounting", 
      "All-Terrain arm with PVC flexibility",
      "90-degree incremental locking"
    ],
    hiddenFromSelection: true
  },
  {
    id: "breakaway-pole-flat-original",
    name: "BeatDown BreakAway Transducer Pole - Deck Mount - Original",
    msrp: 550.00, // Updated MSRP
    csvLookupId: "BeatDown BreakAway Transducer Pole - Deck Mount - Original",
    priceComparisonUrl: getPriceComparisonUrl("BeatDown BreakAway Transducer Pole - Deck Mount - Original"),
    image: "https://thebasstank.com/cdn/shop/products/BD-OUT-TPOLE-BA_ad7eb408-0f90-4de2-a558-7c60e5e44d18.jpg?v=1689628624",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=BreakAway+Flat+Original",
    description: "BreakAway pole with Deck Mount and Original arm. Patent-pending breakaway design with classic 2-section aluminum construction.",
    bestFor: "Professional Anglers",
    notes: "Patent No. US 11,021,215 B1. Does NOT come with mounting hardware. WARNING: REMOVE UNIT WHEN TRAILERING",
    configuration: "BreakAway + Deck Mount + Original",
    construction: "Marine grade aluminum",
    poleType: "BreakAway",
    mountType: "Deck Mount",
    armType: "Original", 
    sections: "2 sections",
    maxLength: "72 inches with extension (sold separately)",
    features: "90-degree locking, damage prevention, standard rigidity",
    benefits: [
      "BreakAway design prevents transducer damage",
      "Universal deck surface mounting",
      "Original arm with standard rigidity", 
      "90-degree incremental locking"
    ],
    hiddenFromSelection: true
  },


  {
    id: "fixed-pole-flat-all-terrain",
    name: "BeatDown Fixed Transducer Pole - Deck Mount - All-Terrain",
    msrp: 375.00, // Updated MSRP
    csvLookupId: "BeatDown Fixed Transducer Pole - Deck Mount - All-Terrain", 
    priceComparisonUrl: getPriceComparisonUrl("BeatDown Fixed Transducer Pole - Deck Mount - All-Terrain"),
    image: "https://thebasstank.com/cdn/shop/products/BD-OUT-TPOLE-BA_ad7eb408-0f90-4de2-a558-7c60e5e44d18.jpg?v=1689628624",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=Fixed+Flat+All-Terrain",
    description: "Fixed position pole with Deck Mount and All-Terrain arm. Universal deck surface mounting with maximum stability.",
    bestFor: "Permanent Installations",
    notes: "Does NOT come with mounting hardware. WARNING: REMOVE UNIT WHEN TRAILERING",
    configuration: "Fixed + Deck Mount + All-Terrain",
    construction: "Marine grade aluminum", 
    poleType: "Fixed",
    mountType: "Deck Mount",
    armType: "All-Terrain",
    sections: "3 sections",
    maxLength: "60 inches without handle",
    features: "Maximum stability, no moving parts, extra flexibility",
    benefits: [
      "Fixed design for maximum stability",
      "Universal deck surface mounting",
      "All-Terrain arm with PVC flexibility",
      "No moving parts for reliability"
    ],
    hiddenFromSelection: true
  },
  {
    id: "fixed-pole-flat-original",
    name: "BeatDown Fixed Transducer Pole - Deck Mount - Original",
    msrp: 375.00, // Updated MSRP
    csvLookupId: "BeatDown Fixed Transducer Pole - Deck Mount - Original",
    priceComparisonUrl: getPriceComparisonUrl("BeatDown Fixed Transducer Pole - Deck Mount - Original"),
    image: "https://thebasstank.com/cdn/shop/products/BD-OUT-TPOLE-BA_ad7eb408-0f90-4de2-a558-7c60e5e44d18.jpg?v=1689628624",
    fallbackImage: "https://dummyimage.com/150x100/cccccc/000000&text=Fixed+Flat+Original",
    description: "Fixed position pole with Deck Mount and Original arm. Classic 2-section design with universal mounting capability.",
    bestFor: "Permanent Installations",
    notes: "Does NOT come with mounting hardware. WARNING: REMOVE UNIT WHEN TRAILERING",
    configuration: "Fixed + Deck Mount + Original",
    construction: "Marine grade aluminum",
    poleType: "Fixed", 
    mountType: "Deck Mount",
    armType: "Original",
    sections: "2 sections", 
    maxLength: "72 inches with extension (sold separately)",
    features: "Maximum stability, no moving parts, standard rigidity",
    benefits: [
      "Fixed design for maximum stability",
      "Universal deck surface mounting",
      "Original arm with standard rigidity", 
      "No moving parts for reliability"
    ],
    hiddenFromSelection: true
  }
  // Add more poles as needed
]; 